export default __webpack_public_path__ + "static/media/Lantra.1223c872.png";